import { Component, OnInit } from '@angular/core';
import {SpecialitesService} from '../../services/specialites/specialites.service';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-show-specialty',
  templateUrl: './show-specialty.component.html',
  styleUrls: ['./show-specialty.component.scss']
})
export class ShowSpecialtyComponent implements OnInit {

    specialty: any;
    endpoint: any;

  constructor(
      private specialitiesService: SpecialitesService,
      private route: ActivatedRoute
  ) {
      const t = this;
      t.endpoint = environment.endpoint;
      if (this.route.snapshot.paramMap.get('friendlyUrl')) {
          this.specialitiesService.find(this.route.snapshot.paramMap.get('friendlyUrl')).subscribe((data: any) => {
              t.specialty = data;
              var  test = [];
              for (let index = 0; index < t.specialty.doctors.length; index++) {

                if(t.specialty.doctors[index].medicalStaffType != null){
                    test.push(t.specialty.doctors[index]);
                }


              }
              t.specialty.doctors = test;
          });
      }
  }

    setFilePath(fileUrl: any) {
        return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
    }

  ngOnInit(): void {
  }

}
